/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import r from '../../../util/Renderer'
import { EditViewLayout } from 'ui-library/dist/external/layouts'
import { ContainedButton, DangerButton, EditContainer, EditField, EditTitleBar, NormalButton, SelectOption, SelectOptions, TextButton, TextInput } from 'ui-library/dist/external/components'
import StripeKeyAction from '../../../action/stripe_key'

function EditView(props) {
  const id = props.match.params.id
  const isUpdate = id ? true : false
  const enableSubmit = true
  return (
    <EditViewLayout>
      <EditContainer
        titleBar={<EditTitleBar title={`Stripe API Keyの設定`} />}
        editAreaTabs={[]}
        footerItems={[
          <TextButton key="cancel" onClick={() => StripeKeyAction.onCancelEditView()}>
            キャンセル
          </TextButton>,
          <ActionButton>{props}</ActionButton>,
          <NormalButton onClick={e => StripeKeyAction.checkConnection(props.stripe_key)}>テスト接続</NormalButton>,
          <DeleteButton>{props}</DeleteButton>
        ]}
      >
        <>
          {[
            <EditField key={`施設`}>
              {r.renderIfOrElse(props.stripe_key.id)(<p>{props.stripe_key.hotel_name}</p>)(
                <SelectOptions label="宿泊施設" name="hotel_id" value={props.stripe_key.hotel_id} onChange={e => StripeKeyAction.onEdit('hotel_id', e.target.value)}>
                  <SelectOption value=""></SelectOption>
                  {props.hotel_options.map((option, index) => (
                    <SelectOption key={`hotel-${index}`} value={option.value}>
                      {option.label}
                    </SelectOption>
                  ))}
                </SelectOptions>
              )}
            </EditField>,
            <EditField key={`シークレットキー`}>
              <TextInput name="api_key" label="シークレットキー" leadingIcon={'vpn_key'} fullWidth value={props.stripe_key.api_key} onChange={e => StripeKeyAction.onEdit('api_key', e.target.value)} />
            </EditField>
          ].reduce((acc, curr) => [acc, '', curr])}
        </>
      </EditContainer>
    </EditViewLayout>
  )
}

function ActionButton(props) {
  const { stripe_key } = props.children

  return (
    <>
      {r.renderIfOrElse(stripe_key.id)(
        <ContainedButton key="update" onClick={() => StripeKeyAction.onRequestUpdate(stripe_key)}>
          更新
        </ContainedButton>
      )(
        <ContainedButton key="create" onClick={() => StripeKeyAction.onRequestCreate(stripe_key)}>
          新規作成
        </ContainedButton>
      )}
    </>
  )
}

function DeleteButton(props) {
  const { stripe_key } = props.children
  return (
    <>
      {r.renderIf(stripe_key.id)(
        <DangerButton
          key="delete"
          onClick={() => {
            if (window.confirm('削除します。よろしいですか？')) {
              StripeKeyAction.onRequestDelete(stripe_key.id)
            }
          }}
        >
          削除
        </DangerButton>
      )}
    </>
  )
}

export default EditView
